import React from "react";
import { IconTypes, RenderIcons } from "./icons";

const _props = {
  reset:Boolean,
  setReset:()=>{}
};
const ResetNewsData = (props = _props) => {
  return (
    <div className="document_header document_icon">
      <span
        className={`reset_icon ${props.reset ? '' : ' disabled'}`}
        onClick={props.reset ? () => {
          props.setSourceName("");
          props.setReset(false)
        }:null}
      >
        {RenderIcons(IconTypes.Reset)} {/* refer icons.js */}
      </span>
    </div>
  );
};

export default ResetNewsData;
